import type { Bilingual } from '../types';

/** Head copy. The served HTML carries it statically for crawlers; this keeps it
 *  in step for a reader who flips the language without reloading. */
const en = {
  title: 'Ordo Research Lab — Rewritable Memory for Frozen LLMs',
  description:
    'Making a local LLM assistant that learns new documentation by diff, not retraining. Open results and negative results from the Ordo-M memory track.',
};

export const meta: Bilingual<typeof en> = {
  en,
  ru: {
    title: 'Ordo Research Lab — перезаписываемая память замороженной модели',
    description:
      'Локальный ассистент, который принимает новую документацию дельтой, а не переобучением. Открытые результаты и отрицательные результаты трека памяти Ordo-M.',
  },
};
